import { DOCUMENT, effect, inject, Injectable, signal } from '@angular/core';
import { SharedCacheService } from '@raxshared/cache.service';

const darkModeIsEnabledCacheKey = 'dark-mode-is-enabled';
const documentBodyDarkThemeCssClass = 'dark-theme';

@Injectable({
    providedIn: 'root',
})
export class DarkModeService {
    private document = inject(DOCUMENT);
    private cacheService = inject(SharedCacheService);

    public darkModeIsEnabled = signal<boolean>(false);

    constructor() {
        effect(() => {
            // applyDarkModeCssClassToBody
            if (this.darkModeIsEnabled()) {
                this.document.body.classList.add(documentBodyDarkThemeCssClass);
                this.cacheService.addLocal<boolean>(darkModeIsEnabledCacheKey, true);
            } else {
                this.document.body.classList.remove(documentBodyDarkThemeCssClass);
                this.cacheService.removeLocal(darkModeIsEnabledCacheKey);
            }
        });
    }

    public initializeDarkModeFromCachedValue(): void {
        const darkModeIsEnabled = this.cacheService.getLocal<boolean>(darkModeIsEnabledCacheKey);

        if (!darkModeIsEnabled) return;
        this.darkModeIsEnabled.set(true);
    }
}
